import { useAppDispatch } from "app/hooks";
import { getLayerName, LayerProps } from "./layerModels";
import { setLayerVisibility } from "features/krpano/details-slice";
import DataItem from "shared/components/DataItem";
import Switch from "shared/components/Switch";
import { useCallback } from "react";

const Layer: React.FC<LayerProps> = ({
  layerName,
  type,
  targetIndex,
  visible,
}) => {
  const dispatch = useAppDispatch();

  const handleLayerToggle = useCallback(
    (newValue: boolean) => {
      dispatch(
        setLayerVisibility([
          {
            type,
            targetIndex,
            visible: newValue,
          },
        ])
      );
    },
    [dispatch, type, targetIndex]
  );

  return (
    <DataItem
      left={getLayerName(layerName)}
      middle={
        <Switch
          name={`ShowHide${type}${layerName}Toggle`}
          size="small"
          checked={visible}
          onChange={handleLayerToggle}
        />
      }
      additionalClasses="Layer"
    />
  );
};

export default Layer;
